import React from 'react';

const DetailRow = ({ title, value }) => (
  <div className='tw-flex tw-w-full tw-gap-4 tw-py-3 tw-px-4 tw-border-b tw-border-solid tw-border-grey-200 tw-border-x-0 tw-border-t-0 last:tw-border-b-0'>
    <span className='tw-text-lg tw-font-medium tw-text-grey-600 tw-w-[240px] tw-shrink-0'>
      {title}
    </span>
    <span className='tw-text-lg tw-font-medium tw-text-grey-800 tw-break-words'>
      {value || '-'}
    </span>
  </div>
);

const toTitleCase = (snakeStr) =>
  (snakeStr || '')
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

const formatAttributeValue = (val) => {
  if (!Array.isArray(val)) return String(val);
  return val
    .map((v) =>
      typeof v === 'object' && v !== null
        ? v.id ?? v.name ?? JSON.stringify(v)
        : v,
    )
    .join(', ');
};

const formatRules = (rules, operatorsMap = {}) => {
  if (!rules || rules.length === 0) return 'No rules configured';
  return rules
    .map((r) => {
      const attrLabel = toTitleCase(r.attribute_name);
      const opLabel = operatorsMap[r.operator] ?? r.operator;
      return `${attrLabel} ${opLabel} ${formatAttributeValue(r.attribute_value)}`;
    })
    .join(', ');
};

const PickupPolicyDetails = ({ policyData, operatorsMap = {} }) => {
  if (!policyData) return null;

  const baseDetails = [
    { key: 'Category Name', value: policyData.category_name },
    { key: 'Complaint Type', value: policyData.complaint_type },
    { key: 'Created By', value: policyData.created_by },
    {
      key: 'Created At',
      value: policyData.created_at
        ? new Date(policyData.created_at).toLocaleString()
        : null,
    },
    { key: 'Updated By', value: policyData.updated_by },
    {
      key: 'Updated At',
      value: policyData.updated_at
        ? new Date(policyData.updated_at).toLocaleString()
        : null,
    },
  ];

  const pickupPolicyEntries = Object.entries(policyData.pickup_policy || {});

  return (
    <div className='tw-border tw-border-solid tw-border-grey-200 tw-rounded-lg tw-bg-white tw-flex tw-flex-col'>
      {baseDetails.map((info) => (
        <DetailRow key={info.key} title={info.key} value={info.value} />
      ))}
      {pickupPolicyEntries.map(([policyKey, policyValue]) => (
        <DetailRow
          key={policyKey}
          title={policyKey}
          value={formatRules(policyValue?.rules, operatorsMap)}
        />
      ))}
    </div>
  );
};

export default PickupPolicyDetails;
